import { create } from 'zustand'
import { RouteState } from '../auth-types'

export const useRouteStore = create<RouteState>((set, get) => ({
  historyRoutes: [],
  pushRoute: path =>
    set(state => {
      if (path === '/' || path === '/meus-atendimentos') {
        return { historyRoutes: [path] }
      }
      if (state.historyRoutes[state.historyRoutes.length - 1] === path)
        return state
      const filteredHistory = state.historyRoutes.filter(
        route => route !== path,
      )
      const newHistory = [...filteredHistory, path].slice(-4)
      return { historyRoutes: newHistory }
    }),
  getPreviousRoute: () => {
    const h = get().historyRoutes
    return h.length < 2 ? null : h[h.length - 2]
  },
}))
